var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-btn',{staticClass:"mr-2",attrs:{"icon":"","color":"primary"},on:{"click":_vm.showSetStarsDialog}},[_c('v-icon',{staticClass:"mr-1"},[_vm._v("mdi-star-outline")]),_vm._v(" "+_vm._s(_vm.coachStars)+" ")],1),_c('set-stars-dialog',{ref:"stars",attrs:{"coach":_vm.coach},on:{"success":_vm.onSuccess}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }